module.exports = __webpack_public_path__ + "static/img/pocketlegal_logo.c1b02b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pocketlegal_logo.png
// module id = 54
// module chunks = 1